import React, { useEffect } from 'react';
import Loader from '../loading/Loader';
import AnimatedHeader from '../animatedLetters/AnimatedHeader';
import { SkillSection } from './skillStyle';

const Skills = () => {
  useEffect(() => {
    eval(
      `try {
       TagCanvas.Start('myCanvas', 'tags', {textColour: '#3bcfe3', noSelect: true, depth: 0.8, outlineColour: '#0000', maxSpeed: 0.02, initial: [-0.800, 0.460]});
     }
     catch(e) {
       document.getElementById('myCanvasContainer').style.display = 'none';
     }`
    );

    return () => {
      eval(`TagCanvas.Delete('myCanvas')`);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <SkillSection>
        <div className='text-zone'>
          <h1>
            <AnimatedHeader
              letterClass={'text-animate-hover'}
              strArray={['Skills', ' ', '&', ' ', 'Experience']}
              idx={30}
            />
          </h1>
          {/* <p>Expert in front-end development including technologies like</p> */}
          <p>
            In the course of my software development journey, I've worked with
            teams with technologies included but no limited to{' '}
          </p>
          <span className='tech-tag'>HTML5, </span>
          <span className='tech-tag'>CSS3, </span>
          <span className='tech-tag'>JavaScript, </span>
          <span className='tech-tag'>jQuery, </span>
          <span className='tech-tag'>TypeScript, </span>
          <span className='tech-tag'>React, </span>
          <span className='tech-tag'>Redux, </span>
          <span className='tech-tag'>Node, </span>
          <span className='tech-tag'>MongoDB, </span>
          <span className='tech-tag'>Express, </span>
          <span className='tech-tag'>Tailwind, </span>
          <span className='tech-tag'>Sass, </span>
          <span className='tech-tag'>Git </span>
          <span className='tech-text'>etc.</span>

          <br />
          <p align='LEFT'>
            I'm not a designer but I have a good sense of aesthetics, and
            experience in responsive, mobile-first web design. I put special
            effort into optimizing my code and providing the best user
            experience. I would love to give you any kind of support also after
            the project's completion. I guarantee a commitment during work on
            your project.
          </p>
          <br />
          <p>
            Visit my
            <a href='https://www.linkedin.com/in/emmanuel-agba' target='blank'>
              LinkedIn
            </a>
            profile for more details. Also you can checkout my resume on this
            <a
              href='https://drive.google.com/file/d/1rOWVzjDYBL888n1iS0NZ8PEWkcEXww4U/view?usp=sharing'
              target='blank'
            >
              link,
            </a>
            or feel free to give a peek on some of my blog
            <a href='/blog'>posts.</a>
          </p>
        </div>
        <div className='cloud-div'>
          <div id='myCanvasContainer'>
            <canvas width='400' height='400' id='myCanvas'>
              <p>
                In Internet Explorer versions up to 8, things inside the canvas
                are inaccessible!
              </p>
            </canvas>
          </div>

          <div id='tags'>
            <ul>
              <li>
                <a aria-disabled='true' href='/skill'>
                  JavaScript
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  HTML
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  CSS
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Gulp
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  ReactJS
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Node
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  MongoDB
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Express
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Git
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  CI/CD
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  webpack
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Jest
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Leaflet
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Mapbox
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Tailwind
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  BootStrap
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  TypeScript
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Redux
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  Jquery
                </a>
              </li>
              <li>
                <a aria-disabled='true' href='/skill'>
                  SCSS
                </a>
              </li>
            </ul>
          </div>
        </div>
      </SkillSection>
      <Loader />
    </>
  );
};

export default Skills;
